import { Link, useLocation } from "react-router-dom";
import { Flame, Home, Newspaper, Store, TrendingUp } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, id: "home" },
  { to: "/deals", label: "Deals", icon: Flame, id: "deals" },
  { to: "/trending", label: "Trending", icon: TrendingUp, id: "trending" },
  { to: "/blog", label: "Blog", icon: Newspaper, id: "blog" },
  { to: "/sell", label: "Sell", icon: Store, id: "sell" },
];

export const BottomNav = () => {
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="mobile-bottom-nav"
      aria-label="Mobile navigation"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur-md md:hidden"
    >
      <div className="grid grid-cols-5">
        {ITEMS.map(({ to, label, icon: Icon, id }) => {
          const active = pathname === to;
          return (
            <Link
              key={id}
              to={to}
              data-testid={`bottom-nav-${id}`}
              className={`flex flex-col items-center gap-0.5 py-2 text-[10px] font-semibold ${
                active ? "text-gold-600" : "text-slate-500"
              }`}
            >
              <Icon size={20} />
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
